export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5005/api';
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
// Api url
